/**
 * @function getTablesStore
 * @param {Object} state The redux store
 * @return {Object} the tableServerSide store
 */
export const getTablesStore = state => state.tableServerSide;

/**
 * @function getTable
 * @param {Object} state The redux store
 * @param {String} tableId the table Id
 * @return {Object} the selected table
 */
export const getTable = (state, tableId) => getTablesStore(state)?.[tableId] || {};

export default {
  getTablesStore,
  getTable
};
